<script setup>
import {defineModel} from 'vue'
// import StageBlock from "@/pages/CreateConnection/StageBlock.vue";


const stages = defineModel('stages')
const stage = defineModel('stage')


function selectStage(selectedStage) {
    stage.value = selectedStage
}

</script>

<template>
    <div class="">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            <div
                v-for="(_stage, index) in stages"
                :key="index"
                v-on:click="selectStage(_stage)"
                v-show="stage.index >= _stage.index"
                class="w-full h-full"
            >
                <div
                    v-show="!_stage.isSkipped"
                    class="w-full h-full flex items-center bg-[#DEEAF7] hover:bg-[#c9d1df] select-none cursor-pointer px-4 py-4 rounded-xl transition-colors duration-200"
                >
                    <div
                        class="flex items-center gap-4"
                        v-if="_stage === stage"
                    >
                        <!-- Номер этапа -->
                        <div class="size-14 rounded-full bg-[#90A4AE] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0">
                            {{ index + 1 }}
                        </div>

                        <!-- Текстовый блок с адаптивными размерами -->
                        <div class="flex-1 min-w-0">
                            <h3 class="font-semibold text-gray-800 text-xl leading-tight">
                                {{ _stage.label }}
                            </h3>
                            <h3 class="font-medium text-gray-600 text-sm leading-snug mt-1">
                                {{ _stage.description }}
                            </h3>
                        </div>
                    </div>
                    <div
                        class="flex items-center gap-4"
                        v-else

                    >
                        <!-- Номер этапа -->
                        <div class="size-10 rounded-full bg-[#90A4AE] text-white flex items-center justify-center font-bold text-base flex-shrink-0">
                            <div>
                                {{ _stage.index }}
                            </div>
                        </div>

                        <!-- Текстовый блок с адаптивными размерами -->
                        <div class="flex-1 min-w-0">
                            <h3 class="font-semibold text-gray-800 text-[clamp(1rem, 4vw, 1.25rem)] leading-tight">
                                {{ _stage.label }}
                            </h3>
                            <h3 class="font-medium text-gray-600 text-[clamp(0.875rem, 3.5vw, 1.125rem)] leading-snug mt-1">
                                {{ _stage.description }}
                            </h3>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<style scoped>
.bg-a {
    background-color: #c9d1df;
}
</style>